import React, { useState, useContext, useEffect } from 'react';
import './styles.css';
import axios from 'axios';
import UserContext from "../../contexts/UserContext";
import usePromoAsset from 'hooks/usePromoAsset';
import LinearLoader from 'components/Loader/LinearLoader';
import useDataLayer from 'hooks/useDataLayer';

function PromoCard({
  promo,
  onParticipate = ()=>{}
}) {
  const { currentUser, setCurrentUser, accessToken, currentPromo } = useContext(UserContext);
  const { asset: image } = usePromoAsset(promo, 'card.png');
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [currentButton, setCurrentButton] = useState({ label: 'ended', class: '...', type: 'button' });
  const dataLayer = useDataLayer();
  
  useEffect(() => {
    switch (promo.status) {
      case 'finished':
        setCurrentButton({
          class: 'ended',
          label: 'FINALIZADA',
          type: 'button',
        });
        break;
      case 'closed':
        setCurrentButton({
          class: 'joined',
          label: promo.id === currentPromo.id ? 'PARTICIPANDO' : 'ACESSAR',
          type: promo.id === currentPromo.id ? 'button' : 'link',
        });
        break;
      case 'joined':
        setCurrentButton({
          class: 'joined',
          label: promo.id === currentPromo.id ? 'PARTICIPANDO' : 'ACESSAR',
          type: promo.id === currentPromo.id ? 'button' : 'link',
        });
        break;
      case 'join': 
        setCurrentButton({
          class: 'join',
          label: 'PARTICIPAR',
          type: 'button',
        });
        break;
      default: 
        setCurrentButton({
          class: 'ended',
          label: 'NÃO ELEGÍVEL',
          type: 'button',
        });
    }
  }, [promo.status]);

  const handleButtonClick = async () => {

    if (loading || promo.status !== 'join') {
      return;
    }

    try {
      setLoading(true);
      axios.post(
          `${process.env.REACT_APP_API_URL}/client/me/participate`,
          { promo_id: promo.id},
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        )
        .then(() => {
          setCurrentUser({ ...currentUser, PromoAtiva: true }, accessToken)
          setErrorMessage('');
          dataLayer.push({
            event: 'participar-promo',
          });
          onParticipate();
        })
        .catch((err) => {
          if (err.response.status === 401) {
            setErrorMessage(
              'Cliente não é elegível para a promoção atual.'
            );
            dataLayer.push({
              event: 'error_event',
              error_code: 401,
              error_message:
                'Cliente não é elegível para a promoção atual. - 401',
            });
          } else if (err.response.status === 400) {
            setErrorMessage('Você já está participando desta promoção.');
            dataLayer.push({
              event: 'error_event',
              error_code: 400,
              error_message:
                'Você já está participando desta promoção. - 400',
            });
          } else {
            console.error(err);
          }
        })
        .finally(() => setLoading(false));
    } catch (error) {
      console.error('Error checking promotion status', error);
    }
  };

  return (
    <div
      className={`promo-card-container ${promo.status === 'join' ? 'promo-card-join' : promo.status === 'joined' ? 'promo-card-joined' : 'promo-card-disabled'}`}
    >
      {promo.status === 'join' && (
        <div className='promo-card-new-alert'>NOVA</div>
      )}
      <p className='promo-card-title notranslate'>{promo.title}</p>
      <div className='promo-card-image-container'>
        <img alt='promo-kv' className='promo-card-image' src={image} />
      </div>
      <p className='promo-card-description'>{promo.description}</p>
      {errorMessage && <p className='promo-card-error'>{errorMessage}</p>}
      {loading ?
        <LinearLoader white={false} /> : <>
          {currentButton.type === 'link' &&
            <a
              className={`promo-card-button ${currentButton.class}`}
              href={`/${promo.path}`}
              target='_blank'
              rel="noreferrer"
            >
              <span>{currentButton.label}</span>
            </a>
          }
          {currentButton.type === 'button' &&
            <button
              className={`promo-card-button ${currentButton.class}`}
              onClick={handleButtonClick}
            >
              <span>{currentButton.label}</span>
            </button>
          }
        </>
      }
    </div>
  );
}

export default PromoCard;
